export enum MessageTypes {
  CONNECT = 'Connect',
  ERROR = 'Error',
  ORDER = 'Order',
}
